import React from "react";
import { useDispatch } from "react-redux";
import { showDrawer, showFindVinModal } from "@app/store/layoutSlice";
import { checkHistoryBenefits } from "./config";
import { CheckHistoryProps } from "./types";
import classes from "./check-history.module.scss";

export const CheckHistory = ({ vin, setVin, error, onSubmit }: CheckHistoryProps) => {
    const dispatch = useDispatch();

    return (
        <div className={classes["check-history"]}>
            <div className={classes["check-history__inner"]}>
                <div className={classes["check-history__background"]}>
                    <p className={classes["check-history__slogan"]}>
                        Полноценная проверка по официальным базам: ДТП, залоги, пробег и полная
                        сервисная история
                    </p>
                    <span className={classes["check-history__source"]}>Источник: Автотека</span>
                </div>
                <div className={classes["check-history__helpers"]}>
                    <button
                        className={classes["check-history__action"]}
                        type="button"
                        onClick={() => dispatch(showFindVinModal())}
                    >
                        Как узнать номер
                    </button>
                    <button
                        className={classes["check-history__action"]}
                        type="button"
                        onClick={() => dispatch(showDrawer())}
                    >
                        Пример отчета
                    </button>
                </div>
                <form className={classes["check-history__form"]} onSubmit={onSubmit}>
                    <input
                        className={classes["check-history__input"]}
                        type="text"
                        placeholder="Госномер, VIN или номер кузова"
                        value={vin}
                        onChange={(e) => setVin(e.target.value)}
                    />
                    <button className={classes["check-history__submit"]} type="submit">
                        Проверить
                    </button>
                    {error && (
                        <div className={classes["check-history__error"]}>
                            Неправильный госномер, VIN или номер кузова
                        </div>
                    )}
                </form>
            </div>
            <div className={classes["check-history__benefits"]}>
                {checkHistoryBenefits.map((item) => (
                    <div key={item.id} className={classes["check-history__benefit"]}>
                        <h3 className={classes["check-history__title"]}>{item.title}</h3>
                        <p className={classes["check-history__desc"]}>{item.text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};